import React from 'react';
import { Link } from 'react-router-dom';

import { canShowAddMoreItems } from '../utils/cartUtils';

interface AddMoreItemsProps {
  order: any;
}

const AddMoreItems: React.FC<AddMoreItemsProps> = ({ order }) => {
  if (!canShowAddMoreItems(order)) {
    return null;
  }

  return (
    <div className="text-center mb-4">
      <Link
        to={'/w'}
        className="btn btn-sm btn-success add-more-items"
        style={{ borderRadius: '10px' }}
      >
        Adicionar mais itens
      </Link>
    </div>
  );
};

export default AddMoreItems;
